import MenuComponent from '@/components/MenuComponent'
import ActualitesComponent from '@/components/ActualitesComponent'
import MenuConnexion from '@/components/MenuConnexion'
import BlocAuthenticated from '@/components/BlocAuthenticated'
import { OperationSearch } from '@/models/operationssearch.model'

export default {
  data () {
    return {
      rechercheRapport: new OperationSearch(),
      rapportsPdf: [],
      loading: false,
      fileToDownload: ''
    }
  },
  components: {
    MenuComponent,
    MenuConnexion,
    BlocAuthenticated,
    ActualitesComponent
  },
  methods: {
    getRapportsToDisplay () {
      if (this.$store.state.user.user.selectedEntreprise) {
        this.loading = true
        this.rechercheRapport.entityId = this.$store.state.user.user.selectedEntreprise.entityId
        this.rechercheRapport.entityLevel = this.$store.state.user.user.selectedEntreprise.entityLevel
        this.rechercheRapport.parentEntityId = this.$store.state.user.user.selectedEntreprise.parentEntityId
        this.rechercheRapport.highEntityId = this.$store.state.user.user.selectedEntreprise.highEntityId

        this.$store.dispatch('entreprise/searchRapports', this.rechercheRapport).then(
          response => {
            this.rapportsPdf = response
            this.loading = false
          },
          error => {
            this.errorMessage = error.response
            this.loading = false
          }
        )
      }
    },
    downloadFile (fileToDownload) {
      let finalFileName = ''
      if (fileToDownload.absolutePath) {
        this.rechercheRapport.fileToDownload = fileToDownload.absolutePath
        this.rechercheRapport.keyFolder = fileToDownload.keyFolder
        finalFileName = fileToDownload.nomFichierTelecharge
      } else {
        this.rechercheRapport.fileToDownload = fileToDownload
        finalFileName = this.rapportsPdf.zipFileName
      }

      this.rechercheRapport.login = this.$store.state.user.user.login

      this.$store.dispatch('entreprise/downloadRapportFile', this.rechercheRapport).then(
        response => {
          let blob = null
          if (finalFileName.indexOf('.pdf') !== -1) {
            blob = new Blob([response], { type: 'application/pdf' })
          } else {
            blob = new Blob([response], { type: 'application/zip' })
          }

          if ('msSaveOrOpenBlob' in navigator) {
            window.navigator.msSaveOrOpenBlob(blob, finalFileName)
          } else {
            var hiddenElement = document.createElement('a')
            hiddenElement.href = URL.createObjectURL(blob)
            hiddenElement.target = '_blank'
            hiddenElement.download = finalFileName
            document.body.appendChild(hiddenElement)
            hiddenElement.click()
            document.body.removeChild(hiddenElement)
          }
          this.loading = false
        },
        error => {
          this.errorMessage = error.response
          this.loading = false
        }
      )
    }
  },
  mounted () {
    this.rechercheRapport.groupName = this.$store.state.user.user.groupe.name
    this.getRapportsToDisplay()
  },
  beforeCreate () {
    this.$store.state.filArianePage = 'Rapports Entreprise'
    this.$store.state.filArianeMiddlePage = null
    this.$store.state.filArianeMiddleRouterLink = null
  }
}
